import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { openBoardSettings } from '../../../../../base/effects/openBoardSettings';
import { TSubTab } from '../../../components/AsidePanel/types';

export const onSubTabChange = (
    subTab: TSubTab,
): ThunkAction => {
    return (dispatch: Dispatch) => {
        dispatch(openBoardSettings(subTab, null, false));
    };
};
